import React from 'react';
import styled from '@emotion/styled';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Colors } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';
import {
  baseMarksElementsConfiguration,
  calloutBody,
} from 'components/RichText/configuration';
import { CalloutBody } from 'data/SingleArticle/types';

const Outer = styled.div`
  background-color: ${Colors.neutral200};
  padding: 15px;
  ${mediaQueries.tablet} {
    padding: 20px;
  }
`;

type Props = {
  body: CalloutBody;
};

export const Callout = ({ body }: Props) => {
  const content = documentToReactComponents(body.json, {
    renderNode: calloutBody,
    renderMark: baseMarksElementsConfiguration,
  });

  return <Outer>{content}</Outer>;
};
